import React from 'react';
import styled from 'styled-components';
import {getLocale} from '@epic-core/common';
import {Typography, AsTagsForSEO} from '../typography/Typography';
import {ArrowRightAlt} from '../icons/ArrowRightAlt';

const EyebrowWrapper = styled.div<{align: string}>`
    text-align: ${(p) => p.align};

    h4 {
        display: inline-block;
    }
    .ue-icon-arrow-right-alt {
        float: right;
        position: relative;
        bottom: 4px;
    }
`;

export interface EyebrowProps {
    align?: string;
    as?: AsTagsForSEO;
    children?: React.ReactNode;
    text?: string;
    hasRightArrow?: boolean;
    big?: boolean;
}

export const Eyebrow = ({
    align = 'inherit',
    as,
    children,
    text,
    hasRightArrow = false,
    big = false
}: EyebrowProps): JSX.Element => {
    return (
        <EyebrowWrapper align={align} className={`eyebrow-wrapper loc-${getLocale()}`}>
            {children ? (
                children
            ) : (
                <Typography variant="h4" as={as} big={big}>
                    {text}
                </Typography>
            )}
            {hasRightArrow && <ArrowRightAlt />}
        </EyebrowWrapper>
    );
};
